import api from "@/lib/api";

/**
 * Upload a Blob (audio recording, canvas capture, etc.) as if it were a file,
 * returning the same shape as the /api/upload endpoint would return for a file input.
 */
export async function uploadBlob(blob, filename) {
  const file = new File([blob], filename, { type: blob.type || "application/octet-stream" });
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { path, content_type, ... }
}
